import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { SportPopup } from 'src/components/SportPopup/SportPopup';
import { getFilters } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.helpers';
import { LiabilitiesFiltersState } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.state';
import { LiabilitiesFiltersProps } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.types';
import {
    CompetitionsFilter,
    CountryFilter,
    DateRangeFilter,
    SearchFilter,
    SportsFilter,
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/components';
import { useAppStateContext } from 'src/AppState/AppState';

export const LiabilitiesFilters = observer(
    'LiabilitiesFilters',
    ({ filters, competitions, onChange }: LiabilitiesFiltersProps) => {
        const { sdkStaff } = useAppStateContext();
        const [liabilitiesState] = useState(() => new LiabilitiesFiltersState(sdkStaff));

        const { sportId, allSports, closeSport, editSport, addCompetition } = liabilitiesState;

        const filteredSports = getFilters(allSports);

        return (
            <div className='row form liabilities-filters'>
                {sportId === null ? null : (
                    <SportPopup
                        id={sportId}
                        onClose={closeSport}
                    />
                )}
                <DateRangeFilter
                    onChange={onChange}
                    range={filters.range}
                />
                <SportsFilter
                    onChange={onChange}
                    sports={filteredSports}
                    sport={filters.sport}
                    editSport={editSport}
                />
                <CountryFilter
                    onChange={onChange}
                    country={filters.country}
                />
                <CompetitionsFilter
                    onChange={onChange}
                    competitions={competitions}
                    competition={filters.competition}
                    addCompetition={addCompetition}
                    sports={allSports}
                />
                <SearchFilter
                    onChange={onChange}
                    query={filters.q}
                />
            </div>
        );
    }
);
